<template>
  <div class="flex items-center justify-between">
    <div>
      <label for="all" class="mr-2">
        {{ $e("Tous les mails") }}
      </label>
      <input
        type="checkbox"
        id="all"
        class="mr-2 !cursor-pointer"
        @change="change_all($event.target.checked)"
      />
    </div>
  </div>

  <div class="max-h-[300px] overflow-x-auto">
    <template v-if="!haveMailingList">
      <p class="text-g4 mt-8 p-3 bg-g3">
        {{ $e("Aucune liste de diffusion") }}
      </p>
    </template>

    <template v-else>
      <div class="flex flex-col mt-2">
        <div
          v-for="(mails, list_name, list_index) in mailing_list"
          :key="list_name"
          class="pt-3 pb-4 px-2"
          :class="{ 'border-g2 border-t-2': list_index > 0 }"
        >
          <!-- START LIST -->
          <div class="flex items-center justify-between mb-2">
            <input
              type="checkbox"
              id="all"
              class="mr-2 !cursor-pointer"
              @change="change_list($event.target.checked, list_name)"
            />
            <span class="text-base font-bold w-full">
              #{{ list_index + 1 }} -
              {{ transform_list_name_to_string(list_name) }} :
            </span>
          </div>
          <div>
            <!-- START MAILS -->
            <div
              v-for="(mail, mail_index) in mails"
              :key="mail_index"
              class="flex items-center mt-1"
            >
              <div
                class="px-2 py-1 mt-1 bg-g2 text-white w-full text-xs cursor-pointer"
                @click="change_mail(mailing_list[list_name][mail_index])"
                :class="{ '!bg-flyingeye': classMails(list_name, mail_index) }"
              >
                {{ mailing_list[list_name][mail_index] }}
              </div>
            </div>
            <!-- END MAILS -->
          </div>
          <!-- END LIST -->
        </div>
      </div>
    </template>
  </div>

  <button
    v-if="haveMailingList"
    @click="send_mail()"
    class="btn text-xs w-full mt-4"
    :class="{ '!bg-g3': !canSend }"
  >
    {{ $e("Envoyer") }}
  </button>

  <template v-if="$root?.global?.site?.sit_id">
    <router-link
      :to="{
        name: 'Site_Edit',
        params: { sit_id: $root.global.site.sit_id },
      }"
      class="block mt-2 text-center text-g3 text-xs underline w-full"
      @click="$emit('close')"
    >
      {{ $e("Modifier votre Liste de diffusion") }}
    </router-link>
  </template>
</template>

<script>
import { ref } from "vue";
import { toast } from "vue3-toastify";
import Mails from "@/utils/Mails";

export default {
  name: "SendEmailList",
  props: {
    template: String,
    subject: String,
    url: String,
  },
  setup() {
    return {
      mails: ref({}),
      site: ref({}),
    };
  },

  beforeMount() {
    this.site = this.$root.global.site;
    this.mailing_list = this.site?.sit_option?.mailing_list ?? [];

    if (this.mailing_list == undefined) {
      this.mailing_list = {};
    }
  },

  methods: {
    transform_list_name_to_string(name) {
      // uppercase first letter
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return name.replace(/_/g, " ");
    },

    change_all(checked) {
      if (checked) {
        let keys = Object.keys(this.mailing_list);

        keys.forEach((key) => {
          this.mailing_list[key].forEach((mail) => {
            this.mails[mail] = mail;
          });
        });
      } else {
        this.mails = {};
      }
      this.$forceUpdate();
    },

    change_mail(index) {
      if (this.mails.hasOwnProperty(index)) {
        delete this.mails[index];
      } else {
        this.mails[index] = index;
      }
      this.$forceUpdate();
    },

    change_list(checked, list_name) {
      if (checked) {
        this.mailing_list[list_name].forEach((mail) => {
          if (!this.mails.hasOwnProperty(mail)) {
            this.mails[mail] = mail;
          }
        });
      } else {
        this.mailing_list[list_name].forEach((mail) => {
          if (this.mails.hasOwnProperty(mail)) {
            delete this.mails[mail];
          }
        });
      }
      this.$forceUpdate();
    },

    send_mail() {
      let keys = Object.keys(this.mails);

      if (keys.length == 0) {
        toast.error(
          this.$e("Veuillez sélectionner au moins un mail"),
          this.$root.toastConfig
        );
        return;
      }

      let mails = "";

      keys.forEach((key) => {
        mails += this.mails[key] + ",";
      });

      Mails.sendEmail(
        this.template,
        "flying.hub456@gmail.com",
        "",
        mails,
        this.subject,
        {
          lien: this.url,
        }
      );
    },

    classMails(list_name, mail_index) {
      return this.mails.hasOwnProperty(
        this.mailing_list[list_name][mail_index]
      );
    },
  },

  computed: {
    canSend() {
      return Object.keys(this.mails).length > 0;
    },

    haveMailingList() {
      return Object.keys(this.mailing_list).length > 0;
    },
  },
};
</script>
